import { makeStyles } from '@material-ui/core/styles';
import { alto, dimGray, silverChalice, white, whiteSmoke, orange } from 'styles/abstract/variables';

export const makeCarouselStyles = makeStyles({
    arrow: {
        background: 'rgba(244, 244, 244, 0.85)',
        borderRadius: '100%',
        boxShadow: `0 0 0.25rem 0 ${silverChalice}`,
        height: '3rem',
        position: 'absolute',
        width: '3rem',
    },
    carouselWrapper: {
        background: whiteSmoke,
        margin: '2rem 1rem 1rem',
        padding: '0.5rem 0 2rem',

        '& .slider-slide > img': {
            margin: 'auto',
            maxHeight: '15rem',
            maxWidth: '85%',
            width: 'auto',
        },

        '& .slider-frame': {
            background: whiteSmoke,
        },
    },
    flipbookLink: {
        alignItems: 'center',
        display: 'flex',
        justifyContent: 'center',
    },
    iconBefore: {
        marginLeft: '-1rem',
    },
    iconNext: {
        marginRight: '-1rem',
    },
    image: {
        '&:hover': {
            cursor: 'pointer',
        },
    },
    title: {
        padding: '0.5rem 1.5rem 1rem',
    },
});

export const makeNavigateIconStyles = makeStyles({
    root: {
        background: white,
        borderRadius: '100%',
        boxShadow: `0.0625rem 0.0625rem 0.25rem 0 ${alto}`,
        color: dimGray,
        fontSize: '2rem',
        transition: 'all 0.3s ease',

        '&:hover': {
            background: orange,
            color: white,
            cursor: 'pointer',
        },
    },
});
